import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { PermissionService } from '../services/permission.service';
import { UserPermission } from '../models/permission.model';
import { map, of } from 'rxjs';

export const permissionGuard = (permission: UserPermission): CanActivateFn => {
  return (route, state) => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    if (permissionService.hasPermission(permission)) {
      return true;
    } else {
      router.navigate(['/']);
      return false;
    }
  };
};
